import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';
import {NgForm} from '@angular/forms';


declare var $: any;
declare var body: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;

@Component({
  selector: 'app-story-detail',
  templateUrl: './story-detail.component.html',
  styleUrls: ['./story-detail.component.css']
})
export class StoryDetailComponent implements OnInit {
  id: number;
  private sub: any;
  description: any;
  title: any;
  date: any;
  coverImage: any;
  data = 'appendix';
  error_count = 0;
  addstoryData: any;
  imageUploadData: any;
  storyData: any;
  changeImg = false;
  image_list = new Array();
  disable = true;
  previewHtml: any;
  author: any;
  editBtndDisable = false;
  //dispensary_id: any;
  businessListig: any;
  constructor(private dataService: DataService, private cs: CountryService, private router: Router, private route: ActivatedRoute) {
    this.dataService.pageName = 'detail story';
    if (window.localStorage.getItem('isauthenticated') !== 'true') {
      window.location.href = '/';
    }
    this.sub = this.route.params.subscribe(params => {
      this.id = +params['id'];
    });
  }
  getDispencryDetail(){
    this.dataService.storyDetail(window.localStorage.getItem('token'), this.id).subscribe(
      (data) => {
        this.storyData = data;
        this.title = this.storyData.title;
        this.description = this.storyData.short_desc;
        this.date = this.storyData.date;
        this.author = this.storyData.admin_name;
        this.coverImage = this.storyData.images[0].url;
        //this.dispensary_id = this.storyData.dispensary_id;
        $('#summernote').summernote('code', this.storyData.html);
      },
      (error) => {
      }
    );
  }

  // businessList(){
  //   this.dataService.getBusinessList(window.localStorage.getItem('token')).subscribe(
  //     (data) => {
  //       this.businessListig = data;
  //       console.log('list', this.businessList);
  //     },
  //     (error) => {
  //     }
  //   );
  // }

  editStory() {
    this.editBtndDisable = true;
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadTextStory').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.imgbackcover').css('border-color', '#ccc');
    this.error_count = 0;
    if (this.title === '' || this.title === undefined) {
      $('#title label').css('color', '#a10a0d');
      $('#title input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.author === '' || this.author === undefined) {
      $('#author label').css('color', '#a10a0d');
      $('#author input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.description === '' || this.description === undefined) {
      $('#description label').css('color', '#a10a0d');
      $('#description input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.coverImage === '' || this.coverImage === undefined || this.coverImage === null) {
      $('.imgbackcover').css('border-color', '#a10a0d');
      $('.uploadTextStory').css('color', '#a10a0d');
      this.error_count ++;
    }
    if (this.error_count > 0) {
      this.editBtndDisable = false;
      return;
    }
    if ( this.changeImg === true ) {
      console.log('if');
      this.image_list = [];
      if(this.storyData.images.length>0){
        this.image_list.push(
          { id: this.storyData.images[0].id,
          is_removed: true
          }
        );
      }else{
        this.image_list=[];
      }
    } else {
      console.log('else');
      this.image_list = [];
      this.image_list.push(
        { id: this.storyData.images[0].id,
          is_removed: false
        }
      );
    }
    var html = $('#summernote').summernote('code');
    console.log(html);
    // this.disable = true;
    this.editBtndDisable = true;
    this.dataService.editStory(window.localStorage.getItem('token'), this.id, this.title, this.description, this.image_list, this.author, html).subscribe(
      (data) => {
        this.addstoryData = data;
        if( this.addstoryData.success === true ){
          if ( this.changeImg === true ) {
            this.uploadStoryImage();
          } else {
            // this.disable = false;
            toastr.success('Story edit sucessfuly');
            this.router.navigate(['story']);
          }
        }
        if( this.addstoryData.success === false ){
          toastr.success('Something went wrong');
          this.editBtndDisable = false;
        }
      },
      (error) => {
      }
    );
  }
  uploadStoryImage(){
    this.dataService.addStoryImage(window.localStorage.getItem('token'), this.id, this.coverImage).subscribe(
      (data) => {
        this.imageUploadData = data;
        this.editBtndDisable = false;
        if( this.imageUploadData.success === true ) {
          this.disable = true;
          toastr.success('Story edit sucessfuly');
          this.router.navigate(['story']);
        }
        if( this.imageUploadData.success === false ) {
          this.disable = false;
          toastr.success('Something went wrong');
        }
      },
      (error) => {
      }
    );
  }

  previewOpenPop(){
    $('.c-label label').css('color', '#3d3e3d');
    $('.uploadTextStory').css('color', '#3d3e3d');
    $('.c-label input').css('border-color', '#ccc');
    $('.imgbackcover').css('border-color', '#ccc');
    this.error_count = 0;
    if (this.title === '' || this.title === undefined) {
      $('#title label').css('color', '#a10a0d');
      $('#title input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.author === '' || this.author === undefined) {
      $('#author label').css('color', '#a10a0d');
      $('#author input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.description === '' || this.description === undefined) {
      $('#description label').css('color', '#a10a0d');
      $('#description input').css('border-color', '#a10a0d');
      this.error_count ++;
    }
    if (this.coverImage === '' || this.coverImage === undefined || this.coverImage === null) {
      $('.imgbackcover').css('border-color', '#a10a0d');
      $('.uploadTextStory').css('color', '#a10a0d');
      this.error_count ++;
    }
    if (this.error_count > 0) {
      return;
    }
    this.previewHtml = $('#summernote').summernote('code');
    $('#preivewPopup').modal('show');
  }

  clearStoryImage() {
    $('.cropit-image-input-story').val('');
  }
  expotyStory() {
    $('.imgbackcover').css('height', 'auto');
    $('.cropit-image-input-story').val('');
    this.coverImage = $('.image-cropper-story').cropit('export', {
      originalSize: true,
      quality: 1,
      type: 'image/png',
    });
    this.changeImg = true;
    $('#cropperStoryImgPop').modal('hide');
  }
  enableEdit(){
    this.disable = false;
    $('.select-image-btn-story').css('background-color', '#d77229');
    $('#summernote').summernote('enable');
  }
  changeimg(){
    if ( this.disable === false ){
    console.log('in');
    $('#cropit-image-input-story').click();
    }
  }
  ngOnInit() {
    this.getDispencryDetail();
    //this.businessList();
    $(document).ready(function() {
      $('#summernote').summernote({
        placeholder: 'Story Description here',
        tabsize: 2,
        height: 300,
        minHeight: 300,
      });
    });
    $('#summernote').summernote('disable');

    setTimeout(() => {
      $('.image-cropper-story').cropit({
        $preview: $('.cropit-preview-story'),
        $fileInput: $('.cropit-image-input-story'),
        $zoomSlider: $('.cropit-image-zoom-input-story'),
        allowDragNDrop: true,
        minZoom: 'fill',
        initialZoom: 'min',
        maxZoom: 20,
        imageBackground: true,
        imageBackgroundBorderWidth: 30,
        smallImage: 'allow',
      });
    }, 1500);
    $('#cropit-image-input-story').change(function() {
      console.log('in image preview2');
      console.log('', $('.cropit-image-input-story').val());
      if ($('.cropit-image-input-story').val() !== '') {
        $('#cropperStoryImgPop').modal('show');
      }
    });
    // $('.select-image-btn-story').click(function() {
    //   console.log('function');
    //   if ( this.disable === false ){
    //     console.log('in');
    //     $('#cropit-image-input-story').click();
    //   }
    // });
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#story').css('color', '#d77229');
    $('.select-image-btn-story').css('background-color', '#cccccc');
  }

}



// WEBPACK FOOTER //
// ./src/app/story-detail/story-detail.component.ts